<template>
  <div id="only_import">
    <a-modal title="单个添加" v-model="onlyVisible" @ok="hideModal" @cancel="hideHandel" okText="确认" cancelText="取消">
      <template slot="footer">
        <a-button @click="hideHandel">关闭</a-button>
        <a-button type="primary" @click="hideModal" :disabled="isdisable">确认</a-button>
      </template>
      <div class="edit_box info_flex">
        <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学校：</span>
        <span>{{teacherAdmin.school_name}}</span>
      </div>
      <div style="margin-top: 16px;">
        <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学生姓名：</span>
        <a-input v-model="editName" placeholder="请输入" style="width: 250px" />
      </div>
      <div style="margin-top: 16px;">
        <span style="display: inline-block; width: 120px; text-align: right; color: #262626">性别：</span>
        <a-select placeholder="请选择" v-model="editSex" style="width: 250px" @change="editSexChange" allowClear>
          <a-select-option v-for="(item, index) in editSexList" :key="index + 'c'" :value="item.id">{{item.val}}</a-select-option>
        </a-select>
      </div>
      <div style="margin-top: 16px;">
        <span style="display: inline-block; width: 120px; text-align: right; color: #262626">学籍号：</span>
        <a-input v-model="editSocial" placeholder="请输入" style="width: 250px" />
      </div>
      <div style="margin-top: 16px;">
        <span style="display: inline-block; width: 120px; text-align: right; color: #262626">身份证号：</span>
        <a-input v-model="editCard" placeholder="请输入" style="width: 250px" />
      </div>
      <div style="margin-top: 16px;">
        <span style="display: inline-block; width: 120px; text-align: right; color: #262626">年级：</span>
        <a-select v-model="editGrade" style="width: 250px" @change="editGradeChange" placeholder="请选择">
          <a-select-option v-for="(item, index) in gradeInfo" :key="index + 'e'" :value="item.id">{{item.val}}</a-select-option>
        </a-select>
      </div>
      <div style="margin-top: 16px;" v-if="userInfo.SCHOOL_TYPE == 2">
        <span style="display: inline-block; width: 120px; text-align: right; color: #262626">专业名称：</span>
        <a-input v-model="editSpecial" placeholder="请输入" style="width: 250px" />
      </div>
      <div style="margin-top: 16px;">
        <span style="display: inline-block; width: 120px; text-align: right">班级：</span>
        <a-select v-model="editClass" style="width: 250px" @change="editClassChange" placeholder="请选择">
          <a-select-option v-for="(item, index) in editClassList" :key="index + 'd'" :value="item">{{`${item}班`}}</a-select-option>
        </a-select>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import STUDENTFUN from '@/util/studentFun'

export default {
  name: 'OnlyImportStu',
  props: ['gradeInfo'],
  data () {
    return {
      editName: null,
      editSex: undefined,
      editSocial: null,
      editCard: null,
      editGrade: undefined,
      editClass: undefined,
      editSpecial: null,
      editSexList: [{id: 1, val: '男'}, {id: 2, val: '女'}],
      editGradeList: null,
      editClassList: STUDENTFUN.classList,
      isdisable: false
    }
  },
  computed: {
    ...mapState({
      teacherAdmin: state => state.teacherAdmin,
      userInfo: state => state.userInfo,
      schoolGrades: state => state.schoolGrades,
      uploadFlag: state => state.uploadFlag,
      onlyUploadFlag: state => state.onlyUploadFlag
    }),
    onlyVisible: {
      get () {
        return this.$store.state.onlyVisible
      },
      set () {
        console.log('wu')
      }
    }
  },
  async mounted () {
    if (this.schoolGrades) {
      this.editGradeList = STUDENTFUN.editGradeReplace(this.schoolGrades)
    }
  },
  methods: {
    ...mapActions([
      // 'getAddStuInfo',
      'getSchoolInfos',
      'uploadStu',
      'logAdd'
    ]),
    ...mapMutations([
      'setOnlyVisible',
      'setStuCurrentNum'
    ]),
    editSexChange (value) {
      this.editSex = value
    },
    editGradeChange (value) {
      console.log(value)
      this.editGrade = value
    },
    editClassChange (value) {
      this.editClass = `${value}班`
    },
    async hideModal () {
      this.isdisable = true
      if (this.userInfo.SCHOOL_TYPE == 2 && this.editGrade >= 10) {
        if (this.editName && this.editSex && this.editGrade && this.editClass && (this.editCard || this.editSocial) && this.editSpecial) {
          let editResult = STUDENTFUN.editTest(this.editCard, this.editSocial, this.editSex)
          if (editResult === 'success') {
            let dataList = {
              CLASS_ID: `${this.editSpecial}${this.editClass.substring(0, this.editClass.length - 1)}`,
              GRADE_ID: this.editGrade,
              REAL_NAME: STUDENTFUN.palindrome(this.editName),
              SEX: this.editSex,
              STUDENT_ID_SOCIAL: !this.editSocial || this.editSocial === '暂无' ? null : this.editSocial,
              STUDENT_ID_CARD: !this.editCard || this.editCard === '暂无' ? null : this.editCard
            }
            try {
              await this.uploadStu(dataList)
              this.isdisable = false
              if (this.uploadFlag) {
                await this.logAdd({
                  name: '学生-学生列表-单个添加学生',
                  remarks: `${STUDENTFUN.palindrome(this.editName)}-${this.editCard ? this.editCard : this.editSocial}`	
                })
                this.setOnlyVisible(false)
                this.$message.success('添加学生信息成功')
                this.clearHandle()
                this.setStuCurrentNum(1)
                await this.getSchoolInfos({skip: 0})
              } else {
                this.$message.error('添加学生信息失败')
              }
            } catch (e) {
              console.log(e)
              this.isdisable = false
              this.$message.info('学生添加超时，请联系工作人员或稍后再试')
            }
          } else {
            this.isdisable = false
            if (editResult === 2) {
              this.$message.warning('身份证号与所填写的性别不符，请核对')
            }
            if (editResult === 3) {
              this.$message.warning('学籍号超过20位了，请修改')
            }
            if (editResult === 5) {
              this.$message.warning('所输入的身份证号无效，请核对')
            }
          }
        } else {
          this.isdisable = false
          if (!this.editName || !this.editSex || !this.editGrade || !this.editClass || !this.editSpecial) {
            this.$message.warning('请将信息填写完整')
          } else {
            if (!this.editCard && !this.editSocial) {
              this.$message.warning('学籍号与身份证至少填写一项')
            }
          }
        }
      } else {
        if (this.editName && this.editSex && this.editGrade && this.editClass && (this.editCard || this.editSocial)) {
          let editResult = STUDENTFUN.editTest(this.editCard, this.editSocial, this.editSex)
          if (editResult === 'success') {
            let dataList = {
              CLASS_ID: this.editClass.substring(0, this.editClass.length - 1),
              GRADE_ID: this.editGrade,
              REAL_NAME: STUDENTFUN.palindrome(this.editName),
              SEX: this.editSex,
              STUDENT_ID_SOCIAL: !this.editSocial || this.editSocial === '暂无' ? null : this.editSocial,
              STUDENT_ID_CARD: !this.editCard || this.editCard === '暂无' ? null : this.editCard
            }
            try {
              await this.uploadStu(dataList)
              this.isdisable = false
              if (this.uploadFlag) {
                await this.logAdd({
                  name: '学生-学生列表-单个添加学生',
                  remarks: `${STUDENTFUN.palindrome(this.editName)}-${this.editCard ? this.editCard : this.editSocial}`	
                })
                this.setOnlyVisible(false)
                this.$message.success('添加学生信息成功')
                this.clearHandle()
                this.setStuCurrentNum(1)
                await this.getSchoolInfos({skip: 0})
              } else {
                this.$message.error('添加学生信息失败')
              }
            } catch (e) {
              console.log(e)
              this.isdisable = false
              this.$message.info('学生添加超时，请联系工作人员或稍后再试')
            }
          } else {
            this.isdisable = false
            if (editResult === 2) {
              this.$message.warning('身份证号与所填写的性别不符，请核对')
            }
            if (editResult === 3) {
              this.$message.warning('学籍号超过20位了，请修改')
            }
            if (editResult === 5) {
              this.$message.warning('所输入的身份证号无效，请核对')
            }
          }
        } else {
          this.isdisable = false
          if (!this.editName || !this.editSex || !this.editGrade || !this.editClass) {
            this.$message.warning('请将信息填写完整')
          } else {
            if (!this.editCard && !this.editSocial) {
              this.$message.warning('学籍号与身份证至少填写一项')
            }
          }
        }
      }
    },
    hideHandel () {
      this.setOnlyVisible(false)
      this.clearHandle()
    },
    clearHandle () {
      this.editName = null
      this.editSex = undefined
      this.editSocial = null
      this.editCard = null
      this.editGrade = undefined
      this.editClass = undefined
      this.editSpecial = null
    }
  }
}
</script>

<style>

</style>
